export default import.meta.ROLLDOWN_FILE_URL_T$TWrbX7dYuHzqRsqeczIQ